import React, { useState } from "react";
import { Parser } from "html-to-react";
import { Popup, Button, IconTiny } from "meitav-uikit";
import restartIcon from "../../../images/Lobby/icon-restart.png";
import closeIcon from "../../../images/common/icon-close-dark-green-bg.png";

function PopupBitcoin({
  openProp,
  setOpen,
  resourceText,
  changeProfileBtn,
  changeAfikBtn,
  okBtnClick,
  icon,
}) {
  const popUpbutton = () => {
    okBtnClick();
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const p = new Parser();
  const body = (
    <div className="paper">
      <div id="simple-modal-description" className="popUpBitcoin generalPopUp">
        <div className="popUpText">{p.parse(resourceText)}</div>
        <div className="popup-actions">
          {changeAfikBtn ? (
            <Button
              className="popUpbutton"
              onClick={handleClose}
              role="button"
              title={`לחץ ${changeAfikBtn}`}
              text={changeAfikBtn}
            ></Button>
          ) : null}
          {changeProfileBtn ? (
            <Button
              className="popUpbutton"
              onClick={popUpbutton}
              role="button"
              title={`לחץ ${changeProfileBtn}`}
              text={changeProfileBtn}
            ></Button>
          ) : null}
        </div>
      </div>
    </div>
  );

  return openProp ? (
    <Popup size="small" hideClose={true}>
      <div className="popup-header-bitcoin">
        <IconTiny src={closeIcon} className="closeIcon" onClick={handleClose} />
        <IconTiny src={restartIcon} />
      </div>
      {body}
    </Popup>
  ) : (
    <></>
  );
}

export default PopupBitcoin;
